import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { EndPointPatiosId } from '../Services/EndPointIngresos';
import api from "../Services/ApiURLBase";
import { URLSalidas } from "../other/apis";
// Create the Salidas context
export const SalidasContext = createContext();

// Custom hook to use the Salidas context
export const useSalidas = () => {
  const context = useContext(SalidasContext);
  if (!context) {
    throw new Error('useSalidas must be used within an SalidasProvider');
  }
  return context;
};

// Provider component
export const SalidasProvider = ({ children }) => {
  const [miningSite, setMiningSite] = useState(0);
  const [warehouse, setWarehouse] = useState(0);
  const [fromDay, setFromDay] = useState(moment().subtract(1, 'month'));
  const [selected, setSelected] = useState(null);
  const [toDay, setToDay] = useState(moment());
  const [warehouses, setWarehouses] = useState([]);
  const [salidas, setSalidas] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const prevMiningSiteRef = useRef(miningSite);
  const isInitialRender = useRef(true);

  const fetchSalidas = async () => {
    try {
      const response = await api.get(
        URLSalidas(
          page,
          miningSite,
          warehouse,
          moment(fromDay).utc().valueOf(),
          moment(toDay).utc().valueOf()
        )
      );

      const salidasData = response.data.result || {};
      setSalidas(salidasData.outputs || []);
      setTotalPages(salidasData.totalPages || 0);
    } catch (error) {
      console.error('Error fetching salidas:', error);
    }
  };

  const fetchYards = async () => {
    try {
      const response = await EndPointPatiosId('0');
      const warehousesData = response.data.data || [];
      setWarehouses(warehousesData);
    } catch (error) {
      console.error('Error fetching yards:', error);
    }
  };

  useEffect(() => {
    fetchYards();
    fetchSalidas();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    const miningSiteChanged = prevMiningSiteRef.current !== miningSite;
  
    if (miningSiteChanged) {
      prevMiningSiteRef.current = miningSite;
      if (warehouse !== 0) {
        setWarehouse(0);
        return;
      }
    }
    
    fetchSalidas();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [miningSite, warehouse, toDay, fromDay, page]);

  const contextValue = {
    miningSite,
    warehouse,
    warehouses,
    fromDay,
    toDay,
    salidas,
    page,
    totalPages,
    selected,
    setSelected,
    setMiningSite,
    setWarehouse,
    setFromDay,
    setToDay,
    setPage
  };

  return (
    <SalidasContext.Provider value={contextValue}>
      {children}
    </SalidasContext.Provider>
  );
}